import { Directive, ElementRef, HostListener, Input, Renderer } from '@angular/core';

@Directive({
  selector: '[menuHover]'
})

export class MenuHoverDirective {

    constructor(private el: ElementRef, private renderer: Renderer) {}
    
    @Input('menuHover') className: string;

    @HostListener('mouseenter') onMouseEnter() {
        this.setClass(this.className, true);
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.setClass(this.className, false);
    }
    
    private setClass(className: string, isAdd: boolean) {
        this.renderer.setElementClass(this.el.nativeElement, className, isAdd);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/directives/MenuHoverDirective.ts